import '../../../proStoreCategories/index.mjs';
import { UniFiChildCategorySlug, UniFiCategoryId } from '../../../proStoreCategories/mapping/unifi.mjs';
import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/DoorAccess/door-hub-mini.jpg.mjs';
import '../../assets/product-list-assets/cameras/door-access/door-hub-mini.jpg.mjs';
import { controlHubs } from '../product-list-groups/controlHubs.mjs';
import '../properties/index.mjs';
import { outputRelays } from '../properties/outputRelays.mjs';
import { inputTerminals } from '../properties/inputTerminals.mjs';
import { poePorts } from '../properties/poePorts.mjs';
import { accessPowerMethod } from '../properties/accessPowerMethod.mjs';
import { powerRedundancy } from '../properties/powerRedundancy.mjs';
import v3Image__default from "../../../../assets/door-hub-mini.jpg";
import image__default from "../../../../assets/door-hub-mini2.jpg";
"use strict";
const doorHubMini = {
  id: "doorHubMini",
  title: "doorHubMini.title",
  description: "doorHubMini.description",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.DoorAccess}/ua-hub-door-mini`],
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessHub,
    productSlug: "ua-hub-door-mini"
  },
  productListGroup: controlHubs,
  image: {
    src: image__default,
    width: 200,
    height: 160
  },
  v3Image: {
    src: v3Image__default,
    width: 266,
    height: 182
  },
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '113 x 66 x 27.6 mm\n(4.4 x 2.6 x 1.1")'
    }
  }, {
    propertyId: outputRelays.id,
    value: {
      type: "translation",
      value: "doorHubMini.outputRelays"
    }
  }, {
    propertyId: inputTerminals.id,
    value: {
      type: "translation",
      value: "doorHubMini.inputTerminals"
    }
  }, {
    propertyId: poePorts.id,
    value: {
      type: "translation",
      value: "doorHubMini.poePorts"
    }
  }, {
    propertyId: accessPowerMethod.id,
    value: {
      type: "string",
      value: "PoE++"
    }
  }, {
    propertyId: powerRedundancy.id,
    value: {
      type: "boolean",
      value: false
    }
  }]
};
export { doorHubMini };
//# sourceMappingURL=doorHubMini.mjs.map
